/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-23 09:07:14
 * @LastEditors: jyf
 * @LastEditTime: 2022-11-25 13:46:38
 */

import Vue from 'vue';
import '@/style/index'; // global css
import "lib-flexible-computer";
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import store from './vuex';
import vueSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';
import preview from 'vue-photo-preview';
import $ from 'jquery'
import dayjs from 'dayjs';
import Bus from './common/util/bus';
import axios from "axios";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import print from './common/util/print'
// Vue.use(print)
import scroll from "vue-seamless-scroll";
import preventClick from './utils/controlClickState'
import format from 'vue-text-format';
Vue.use(preventClick)
Vue.use(Viewer)
Vue.use(scroll)
Vue.use(format)
// import TIM from 'tim-js-sdk';
// import TIMUploadPlugin from 'tim-upload-plugin';
// let options = {
//     SDKAppID: 1400512528
// };
// let tim = TIM.create(options);
// tim.setLogLevel(1);
// tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});
Vue.prototype.window = window;
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$print = print
Vue.use(vueSwiper)
    .use(VueClipboard)
    .use(preview)
    .use(ElementUI, {
        size: 'small',
        zIndex: 1000
    });
Vue.config.productionTip = false;
Vue.prototype.TITLE = process.env.TITLE;
Vue.prototype.$store = store;
Vue.prototype.$axios = axios;
Vue.prototype.$bus = Bus;
Vue.prototype.$dayjs = dayjs;
import directive from './directive';
Vue.use(directive);
export default new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});
